window.alpineEnquiryFormData = function()
{
    return {
        isOpen: false,
        slideIndex: 0,
        animationFinished: true,
        isBusy: false,
        errors: {},

        project_type: "",
        project_service: "",
        budget: "",
        source: "",
        firstname: "",
        lastname: "",
        phone: "",
        email: "",
        deadline: "",
        enquiry: "",

        setIsOverflowDisabled(value)
        {
            if (value === true){
                document.querySelector("html").style.overflow = "hidden";
                document.querySelector("html").classList.add("hidden-scroll");
                window.scroll.stop();
            }
            else {
                document.querySelector("html").style.overflow = null;
                document.querySelector("html").classList.remove("hidden-scroll");
                window.scroll.start();
            }
        },

        submit()
        {
            if (this.isBusy){
                return;
            }

            this.isBusy = true;

            const formData = new FormData();
            formData.append("project_type", this.project_type);

            if (this.project_type === 'digital marketing'){
                formData.append("project_service", this.project_service);
            }
            else {
                formData.append("budget", this.budget);
            }
            
            formData.append("source", this.source);
            formData.append("firstname", this.firstname);
            formData.append("lastname", this.lastname);
            formData.append("phone", this.phone);
            formData.append("email", this.email);
            formData.append("deadline", this.deadline);
            formData.append("enquiry", this.enquiry);
            formData.append("simple_captcha", this.$refs.simple_captcha.value);
            formData.append("simple_captcha_confirmation", this.$refs.simple_captcha_confirmation.value);

            window.axios.post("/api/form/enquiry", formData).then(response => {
                this.slideIndex = -1;
            }).catch(error => {
                console.error(error);
                if (error.response && error.response.status == 422){
                    this.errors = error.response.data;
                }
            }).finally(() => {
                this.isBusy = false;
            });
        }
    };
};
